export interface LibraryConfig {
  env: string;
  apiUrl: string;
  bucketUrl: string;
  apiKey?: string;
  enableDebugMode: boolean;
}

// Opcionalmente, un InjectionToken para la configuración
import {InjectionToken} from '@angular/core';
export const LIBRARY_CONFIG = new InjectionToken<LibraryConfig>('library.config');
